export const UPLOAD_ACTION = "UPLOAD_ACTION";
export const UPLOAD_SUCCESS = "UPLOAD_SUCCESS";

export const UPLOAD_INIT = "UPLOAD_INIT";
export const UPLOAD_FAIL = "UPLOAD_FAIL";
